// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"2274bef5","513":"5543ca31","703":"46cf57bb"}[chunkId] + ".chunk.js";
};